import axios from "axios";

const api = axios.create({
  baseURL: "https://arjtech.xyz/sales_backend/api/",
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

api.interceptors.request.use(
  (config) => {
    const user_data = JSON.parse(localStorage.getItem("user_data") ?? "{}");
    const client = JSON.parse(localStorage.getItem("client") ?? "{}");


    if (!client?.username) {
      window.location.href = "/login";
      return Promise.reject(new Error("Client not verified"));
    }

    if (!user_data?.id) {
      window.location.href = "/login";
      return Promise.reject(new Error("Unauthorized"));
    }



    const dataAdd = {
      product_name: "SCAI",
      client_username: client?.username,
      user_id: user_data.id,
      user_name: user_data.name,
      user_mobile_no: user_data.phone,
    };
    
    if (["post", "put", "patch"].includes(config.method)) {
      if (config.data instanceof FormData) {
        Object.entries(dataAdd).forEach(([key, value]) => {
          config.data.append(key, value ?? "");
        });
      } else {
        config.data = {
          ...(config.data || {}),
          ...dataAdd,
        };
      }
    }
    
    if (config.method === "get") {
      config.params = {
        ...(config.params || {}),
        ...dataAdd,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const addIssue = async (data) => {
  return await api.post(`issue/post`, data);
};

export const issuesList = async (addUrl = "") => {
  return await api.get(`issue/list?${addUrl}`);
};

export const getARJDetails = async () => {
  return await api.get(`get/business/details`);
};
